import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Image } from 'foundations-components/transitional/components/Image';
import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetSearchBarResult({
  companyName,
  name,
  offeringType,
  thumbnailUrl
}) {
  const offeringTypeIsModule = offeringType === OfferingType.MODULE;
  const uiBadgeColor = offeringTypeIsModule ? 'norman' : 'thunderdome';
  return /*#__PURE__*/_jsx(MediaObject, {
    itemLeft: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "60px",
      blockSize: "48px",
      children: /*#__PURE__*/_jsx(Image, {
        src: thumbnailUrl,
        maxInlineSize: "100%",
        role: "presentation"
      })
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          typography: "heading-50",
          marginBlockEnd: "100",
          children: name
        }), /*#__PURE__*/_jsx(Badge, {
          marginInlineStart: "200",
          use: uiBadgeColor,
          children: offeringType
        })]
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.assets.assetSearchBarResult.companyName",
          options: {
            companyName
          }
        })
      })]
    })
  });
}